<script setup>
import MainNav from '@/components/MainNav.vue'
import MobileHeader from '@/components/MobileHeader.vue'
import yachtwiselyLogoImg from '@/assets/images/yachtwisely-logo.svg'
import { useAuthStore } from '@/stores';

const authStore = useAuthStore()
</script>

<template>
  <MobileHeader />

  <div
    id="application-sidebar-dark"
    class="hs-overlay hs-overlay-open:translate-x-0 -translate-x-full transition-all duration-300 transform hidden fixed top-0 start-0 bottom-0 z-[60] w-64 bg-gray-900 border-e border-gray-800 py-10 overflow-y-auto flex-col lg:flex lg:translate-x-0 lg:end-auto lg:bottom-0 [&::-webkit-scrollbar]:w-2 [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-track]:bg-gray-100 [&::-webkit-scrollbar-thumb]:bg-gray-300"
  >    <div class="px-6">
      <RouterLink
        :to="'/'"
        class="block flex-none text-xlfont-semibold text-white focus:outline-none focus:ring-1 focus:ring-gray-600"
      >
        <img :src="yachtwiselyLogoImg" alt="Yachtwisely logo" height="41" width="180" />
      </RouterLink>
    </div>

    <MainNav />
  </div>
</template>
